import React from "react";

const POINTS = [
  { event: "Goal scored (group stage)", pts: 1, icon: "⚽" },
  { event: "Goal scored (knockout stage)", pts: 2, icon: "⚽" },
  { event: "Group stage win", pts: 3, icon: "✅" },
  { event: "Group stage draw", pts: 1, icon: "🤝" },
  { event: "Advance to knockout round", pts: 2, icon: "🎟️" },
  { event: "Group winner bonus", pts: 5, icon: "🥇" },
  { event: "Round of 32 win", pts: 10, icon: "🏅" },
  { event: "Round of 16 win", pts: 20, icon: "🏅" },
  { event: "Quarterfinal win", pts: 40, icon: "🌟" },
  { event: "Semifinal win", pts: 80, icon: "🌟" },
  { event: "Champion", pts: 150, icon: "🏆" },
];

function HowToPlay({ onClose, onJoin }) {
  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.8)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={onClose}
    >
      <div
        style={{ background: "#112240", border: "1px solid rgba(255,215,0,0.2)", borderRadius: 16, padding: 28, maxWidth: 560, width: "100%", maxHeight: "90vh", overflowY: "auto", position: "relative" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={onClose} style={{ position: "absolute", top: 16, right: 16, background: "rgba(255,255,255,0.1)", border: "none", fontSize: 16, cursor: "pointer", color: "white", width: 32, height: 32, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>

        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 30, color: "#FFD700", letterSpacing: 2, marginBottom: 4 }}>HOW TO PLAY</div>
        <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 13, marginBottom: 24 }}>2026 FIFA World Cup Pool</div>

        {[
          { title: "THE DRAFT", color: "#FFD700", content: "All 48 World Cup teams are divided into 10 tiers based on their odds to win the tournament. Tiers 1–6 have 4 teams each (clear favorites), Tiers 7–10 have 6 teams each (longshots). Pick one team from every tier — 10 picks total." },
          { title: "ENTRIES", color: "#00C853", content: "Players pick independently without seeing each other's selections. Multiple entries per person are allowed. Picks must be submitted before June 11, 2026 — once the first game starts, picks are locked." },
        ].map((section) => (
          <div key={section.title} style={{ marginBottom: 20 }}>
            <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 16, color: section.color, letterSpacing: 2, marginBottom: 6 }}>{section.title}</div>
            <p style={{ fontSize: 14, color: "rgba(255,255,255,0.65)", lineHeight: 1.6 }}>{section.content}</p>
          </div>
        ))}

        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 16, color: "#E53935", letterSpacing: 2, marginBottom: 10 }}>SCORING</div>
        <div style={{ border: "1px solid rgba(255,255,255,0.08)", borderRadius: 10, overflow: "hidden", marginBottom: 20 }}>
          {POINTS.map((row, i) => (
            <div key={row.event} style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "9px 14px",
              background: i % 2 === 0 ? "rgba(255,255,255,0.03)" : "transparent",
              borderBottom: i < POINTS.length - 1 ? "1px solid rgba(255,255,255,0.05)" : "none"
            }}>
              <span style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", display: "flex", alignItems: "center", gap: 8 }}>
                <span>{row.icon}</span>{row.event}
              </span>
              <span style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 20, color: "#FFD700", minWidth: 40, textAlign: "right" }}>
                +{row.pts}
              </span>
            </div>
          ))}
        </div>

        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 16, color: "#00C853", letterSpacing: 2, marginBottom: 8 }}>NOTES</div>
        <ul style={{ paddingLeft: 18, fontSize: 13, color: "rgba(255,255,255,0.55)", lineHeight: 2 }}>
          <li><strong style={{ color: "rgba(255,255,255,0.8)" }}>Penalty shootout kicks do not count as goals</strong> — only goals scored in regulation and extra time count towards your pool points.</li>
          <li>All picks are visible to everyone once the tournament begins.</li>
          <li>Scores update every <strong style={{ color: "rgba(255,255,255,0.8)" }}>1 minute</strong> during match days and every 5 minutes on non-match days. Hit Refresh on the leaderboard to see the latest.</li>
        </ul>

        <button onClick={onJoin || onClose} className="btn btn-primary btn-full btn-lg" style={{ marginTop: 24, borderRadius: 10 }}>
          Got it — Let's Join! ⚽
        </button>
      </div>
    </div>
  );
}

export default HowToPlay;
